module.exports = __webpack_public_path__ + "img/eldorUsaLogo.42589068.png";